import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/jquery.validate.min.js';
import wx from 'jweixin-npm';

palyvideo()
function palyvideo(){
  if($('video').length>0){
    let videolist = $('video')
    console.log(videolist)
    for(let i=0; i<videolist.length; i++){
      videolist[i].play()
    }
  }
}

document.addEventListener("WeixinJSBridgeReady", function () {
  palyvideo()
}, false);

let pro_tab_swiper //整体tab--swiper
let contTopArr = [] //各部分offset-top
let sec3swiper //图文swiper
let sec3TopArr = [] //图文各部分offset-top
$(document).ready(function(){
  var langtext = $(".language .lan-title span").text();
  if(langtext == 'EN'){
    $("#pro_form").validate();
  }
  
 
  //浮动tab
  let pro_tab_h = $('.section1 .sec-tab').outerHeight()
  $('.section1').css('height', pro_tab_h + 'px');
  $('.section1 .sec-tab .swiper-slide').eq(0).addClass('active')
  pro_tab_swiper = new Swiper(".section1 .sec-tab .mySwiper", {
    centeredSlides: true,
    centeredSlidesBounds: true,
    centerInsufficientSlides: true,
    slidesPerView : 'auto',
    spaceBetween: 15,
    watchOverflow: true,
    breakpoints: {
      768: {
        spaceBetween: 30,
        centeredSlides: false,
      },
      1280: {
        spaceBetween: 60,
        centeredSlides: false,
      }
    },
  })
  
  // 点击tab页面滚动到对应部分
  $('.section1 .sec-tab .swiper-slide').on('click',function(){
    let index = $(this).index()
    $("html, body").animate({
      scrollTop: $('.pro-cont section').eq(index).offset().top + "px"
    }, {
        duration: 500,
        easing: "swing"
    });
    return false;
  })

  // 图片滚动swiper
  sec3swiper = new Swiper(".section3 .right-swiper .mySwiper", {
    allowTouchMove: true,
    effect : 'fade',
    fadeEffect: {
      crossFade: true,
    },
    pagination: {// 分页
      el: ".section3 .right-swiper .swiper-pagination",
      clickable: true
    },
    breakpoints: { 
      1025: {
        allowTouchMove: false,
      }
    }
  })
  if($(window).width() > 1024){
    //获取图文各部分top
    $('.section3 .left-img .img').each(function(index){
      sec3TopArr.push($(this).offset().top - $(window).height()/2)
    })

    $('.section3 .right-swiper').on('click','.swiper-pagination-bullet',function(){
      let index = $(this).index()
      $("html, body").animate({
        scrollTop: $('.section3 .left-img .img').eq(index).offset().top + "px"
      }, {
          duration: 500,
          easing: "swing"
      });
      return false;
    })
  }

  // Product Parameter
  let sec4swiper = new Swiper(".section4 .sec4-swiper .mySwiper", {
    allowTouchMove: false,
    autoHeight: true,
    effect : 'fade',
    fadeEffect: {
      crossFade: true,
    },
    on:{
      init: function(swiper){
        $('.section4 .sec4-tab div').eq(0).addClass('active')
      },
      slideChangeTransitionStart: function(){
        $('.section4 .sec4-tab div').eq(this.realIndex).addClass('active').siblings().removeClass('active')
      },
    },
  })
  $('.section4 .sec4-tab div').on('click',function(){
    let index = $(this).index()
    sec4swiper.slideTo(index)
  })

  //Relevant Industries
  let sec6swiper = new Swiper(".section6 .sec6-swiper .mySwiper", {
    slidesPerView: 1,
    spaceBetween: 10,
    resizeObserver: true,
    watchOverflow: true,
    navigation: {//按钮
      nextEl: ".section6 .sec6-swiper .swiper-button-next",
      prevEl: ".section6 .sec6-swiper .swiper-button-prev",
    },
    breakpoints: { //响应式
      640: {  //当屏幕宽度大于等于320
        slidesPerView: 2,
        spaceBetween: 10
      },
      769: {  //当屏幕宽度大于等于768 
        slidesPerView: 3,
        spaceBetween: 20
      },
      1280: {  //当屏幕宽度大于等于1280
        slidesPerView: 4,
        spaceBetween: 30
      }
    },
    on:{
      init: function(swiper){
        if(this.isLocked){
          $('.section6 .sec6-swiper .swiper-btn').hide()
        }
      },
      resize: function(){
        if(this.isLocked){
          $('.section6 .sec6-swiper .swiper-btn').hide()
        }else{
          $('.section6 .sec6-swiper .swiper-btn').show()
        }
      },
    },
  })

  // Recommend Product
  let sec7swiper = new Swiper(".section7 .sec7-swiper .mySwiper", {
    slidesPerView: 1,
    spaceBetween: 10,
    resizeObserver: true,
    watchOverflow: true,
    navigation: {//按钮
      nextEl: ".section7 .sec7-swiper .swiper-button-next",
      prevEl: ".section7 .sec7-swiper .swiper-button-prev",
    },
    breakpoints: { //响应式
      640: {  //当屏幕宽度大于等于320
        slidesPerView: 2,
        spaceBetween: 10
      },
      769: {  //当屏幕宽度大于等于768 
        slidesPerView: 3,
        spaceBetween: 20
      },
      1280: {  //当屏幕宽度大于等于1280
        slidesPerView: 4,
        spaceBetween: 30
      }
    },
    on:{
      init: function(swiper){
        if(this.isLocked){
          $('.section7 .sec7-swiper .swiper-btn').hide()
        }
      },
      resize: function(){
        if(this.isLocked){
          $('.section7 .sec7-swiper .swiper-btn').hide()
        }else{
          $('.section7 .sec7-swiper .swiper-btn').show()
        }
      },
    },
  })
})

$(window).resize(function(){
  //计算浮动tab占位高度
  let pro_tab_h = $('.section1 .sec-tab').outerHeight()
  $('.section1').css('height', pro_tab_h + 'px');

  if($(window).width() > 1024){
    //重新获取图文各部分top
    sec3TopArr = []
    $('.section3 .left-img .img').each(function(index){
      sec3TopArr.push($(this).offset().top - $(window).height()/2)
    })
  }
})

$(document).scroll(function () {
  let scroH = $(document).scrollTop(); //滚动高度
  let viewH = $(window).height(); //可见高度
  let pro_tabTop = $('.section1').offset().top

  //tab--浮动
  if (scroH > pro_tabTop) {
    $('.header').addClass('trans')
    $('.section1 .sec-tab').addClass('fixed')
  }else{
    $('.header').removeClass('trans')
    $('.section1 .sec-tab').removeClass('fixed')
  }

  if(contTopArr.length == 0 || contTopArr.slice(-1) != $('.pro-cont section').last().offset().top - $(window).height()/2){
    //获取各部分top
    contTopArr = []
    $('.pro-cont section').each(function(index){
      contTopArr.push($(this).offset().top - $(window).height()/2)
    })
  }

  //各部分tab对应
  for(let i=0; i < contTopArr.length; i++){
    if(scroH < contTopArr[1]){
      $('.section1 .sec-tab .swiper-slide').eq(0).addClass('active').siblings().removeClass('active')
      pro_tab_swiper.slideTo(0)
    }
    if(i > 0 && i < contTopArr.length - 1){
      if(scroH > contTopArr[i] && scroH < contTopArr[i+1]){
        $('.section1 .sec-tab .swiper-slide').eq(i).addClass('active').siblings().removeClass('active')
        pro_tab_swiper.slideTo(i)
      }
    }
    if(scroH > contTopArr.slice(-1)){
      $('.section1 .sec-tab .swiper-slide').eq(contTopArr.length-1).addClass('active').siblings().removeClass('active')
      pro_tab_swiper.slideTo(contTopArr.length-1)
    }
  }

  // 图片滚动文字浮动
  if($(window).width() > 1024){
    if($('.section3').length > 0){
      let fixedTop = $('.section3').offset().top
      let fixedBtm = $('.section3').offset().top + $('.section3').outerHeight() - $('.section3 .right-swiper').outerHeight()
      if (scroH < fixedTop) {
        $('.section3 .right-swiper').removeClass('fixed')
      }else if (scroH > fixedTop && scroH < fixedBtm) {
        $('.section3 .right-swiper').addClass('fixed').removeClass('abs')
      }else{
        $('.section3 .right-swiper').addClass('abs').removeClass('fixed')
      }

      // 图片滚动文字浮动
      for(let i=0; i < sec3TopArr.length; i++){
        if(scroH < sec3TopArr[1]){
          sec3swiper.slideTo(0)
        }
        if(i > 0 && i < sec3TopArr.length - 1){
          if(scroH > sec3TopArr[i] && scroH < sec3TopArr[i+1]){
            sec3swiper.slideTo(i)
          }
        }
        if(scroH > sec3TopArr[sec3TopArr.length - 1]){
          sec3swiper.slideTo(sec3TopArr.length-1)
        }
      }
    }
  }
});

